import { useParams } from 'react-router-dom';
import { CardType } from '../../../../enums';
import { TopUpGenericCardPage } from './TopUpGenericCardPage';
import { TopUpGiftCardPage } from './TopUpGiftCardPage';

export const TopUpCardPage = () => {
  const params = useParams();

  if (!params?.cardTypeId) return null;

  if (Number.parseInt(params.cardTypeId) === CardType.Gift) {
    return <TopUpGiftCardPage />;
  }

  return <TopUpGenericCardPage />;
};
